import script from "./selectTag.vue?vue&type=script&setup=true&lang=js"
export * from "./selectTag.vue?vue&type=script&setup=true&lang=js"

import "./selectTag.vue?vue&type=style&index=0&id=5e3d6686&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3d6686"]])

export default __exports__